import * as firebase from 'firebase/app'
import 'firebase/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyD21rZnlmR1fDk5h05RWkjFnqVnWIyp4e8',
  authDomain: 'swizzleee-portfolio.firebaseapp.com',
  databaseURL: 'https://swizzleee-portfolio.firebaseio.com',
  projectId: 'swizzleee-portfolio',
  storageBucket: '',
  messagingSenderId: '521142744904',
  appId: '1:521142744904:web:db9ec25595ee04c7'
}

const app = firebase.initializeApp(firebaseConfig)

export default app
